import { createCrudSlice, createCrudSliceSelectors } from '@/store/util';

import { editMe, updateMe } from './actions';

const options = {
  name: 'me',
  // collectionName: 'users',
  recordName: 'user',
  actionsConfig: {
    update: {
      read: editMe,
      write: updateMe,
      noIndex: true,
    },
  },
};

export const { update: selectMeForUpdate } = createCrudSliceSelectors(options);

const { reducer } = createCrudSlice(options);
export default reducer;
